import {
  LOGIN,
  LOGOUT,
  SET_CURRENT_PROFILE,
  SET_PROFILE,
  SET_TOKEN,
  SET_MFA_TOKEN,
  SET_MFA_USER,
  CLEAR_MFA,
} from "../actions/actionTypes";

const initialState = {
  user: {},
  profiles: {},
  currentProfile: {},
  mfaToken: null,
  mfaUser: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOGIN:
      return {
        ...state,
        user: action.payload,
        mfaToken: null,
        mfaUser: null,
      };
    case SET_TOKEN:
      return {
        ...state,
        token: action.payload,
      };
    case SET_PROFILE:
      return {
        ...state,
        profiles: action.payload,
      };
    case SET_CURRENT_PROFILE:
      return {
        ...state,
        currentProfile: action.payload,
      };
    case SET_MFA_TOKEN:
      return {
        ...state,
        mfaToken: action.payload,
      };
    case SET_MFA_USER:
      return {
        ...state,
        mfaUser: action.payload,
      };
    case CLEAR_MFA:
      return {
        ...state,
        mfaToken: null,
        mfaUser: null,
      };
    case LOGOUT:
      return {
        ...state,
        user: {},
        profiles: {},
        currentProfile: {},
        mfaToken: null,
        mfaUser: null,
      };
    default:
      return state;
  }
};
